import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Button } from '@smartplatform/ui';
import t from '../../../i18n';

const VIDEO_DOMAINS = {
	youtube: ['youtu.be', 'www.youtube.com'],
	rutube: ['rutube.ru'],
	vk: ['vkvideo.ru', 'vk.com'],
	dzen: ['dzen.ru'],
	platform: ['plvideo.ru'],
};

@observer
export class VideoItem extends React.Component {
	@observable error = null;
	@observable videoId = null;

	constructor(props) {
		super(props);
		this.init();
	}

	init = () => {
		this.getVideoId(this.props.url);
		if (this.props.onVideoUrlChange) this.props.onVideoUrlChange(this.props.url, this.props.index, !!this.videoId);
	};

	onVideoUrlChange = (event, index) => {
		const value = event.target.value;
		this.getVideoId(value);
		if (this.props.onVideoUrlChange) this.props.onVideoUrlChange(value, index, !!this.videoId);
	};

	getVideoId = url => {
		let value;
		this.error = null;
		try {
			const parsedUrl = new URL(url);
			const host = parsedUrl.host;
			let source;
			for (const sourceKey in VIDEO_DOMAINS) {
				if (VIDEO_DOMAINS[sourceKey].includes(host)) {
					source = sourceKey;
					break;
				}
			}

			if (!source) {
				this.error = t('video.error.invalidSource');
			} else {
				if (!this.hasOwnProperty(`${source}GetId`)) {
					this.error = t('video.error.invalidSource');
				} else {
					value = this[`${source}GetId`](parsedUrl);
					if (!value) this.error = t('video.error.invalidURL');
				}
			}
		} catch (error) {
			this.error = t('video.error.invalidURL');
			console.error(error);
		}
		this.videoId = value;
	};

	platformGetId = urlObject => {
		let videoId;
		videoId = urlObject.searchParams.get('v');
		if (!videoId) {
			const pathNameItems = urlObject.pathname.split('/');
			if (pathNameItems?.[1] === 'embed' && pathNameItems?.[2]) videoId = pathNameItems[2];
		}
		return videoId;
	};

	dzenGetId = urlObject => {
		let videoId;
		const pathNameItems = urlObject.pathname.split('/');
		if (pathNameItems?.[1] === 'embed' && pathNameItems?.[2]) videoId = pathNameItems[2];
		return videoId;
	};

	vkGetId = urlObject => {
		let videoId;
		videoId = urlObject.searchParams.get('id');
		if (!videoId) {
			const pathNameItems = urlObject.pathname.split('/');
			if (pathNameItems.length) {
				// В URL видео, если не через searchParams id видео хранится в формате "video-218471753_456239134", где последняя цифра id видео
				const videoParamsPathName = pathNameItems[1].split('-');
				if (videoParamsPathName?.[0] === 'video' && videoParamsPathName?.[1]) {
					const videoParams = videoParamsPathName[1].split('_');
					if (videoParams?.[1]) videoId = videoParams[1];
				}
			}
		}
		return videoId;
	};

	rutubeGetId = urlObject => {
		let videoId;
		const pathNameItems = urlObject.pathname.split('/');
		if (pathNameItems?.[1] === 'video' && pathNameItems?.[2]) videoId = pathNameItems[2];
		if (pathNameItems?.[1] === 'play' && pathNameItems?.[2] === 'embed' && pathNameItems?.[3]) videoId = pathNameItems[3];
		return videoId;
	};

	youtubeGetId = urlObject => {
		let videoId;
		videoId = urlObject.searchParams.get('v');
		if (!videoId) {
			const pathNameItems = urlObject.pathname.split('/');
			if (pathNameItems?.[1] === 'embed' && pathNameItems?.[2]) videoId = pathNameItems[2];
		}
		return videoId;
	};

	onDelete = index => {
		if (this.props.onDelete) this.props.onDelete(index);
	};

	render() {
		const { url, index } = this.props;
		return (
			<div className="wrapper-video-item">
				<div className="row">
					<div className="col-lg-8 col-ms-8 col-sm-8 col-12 form-field">
						<label>Видео URL</label>
						<input type="text" value={url} onChange={e => this.onVideoUrlChange(e, index)} />
					</div>
					<div className="col-lg-3 col-ms-3 col-sm-3 col-11 form-field">
						<label>Видео ID (если пустое - значит URL видео некорректное):</label>
						<input type="text" value={this.videoId || '-'} disabled />
					</div>
					<div className="col-lg-1 col-ms-1 col-sm-1 col-1 form-field">
						<label>&nbsp;</label>
						<Button onClick={e => this.onDelete(index)}>Удалить</Button>
					</div>
				</div>
				{this.error && <span className="error">{this.error}</span>}
			</div>
		);
	}
}
